import React from "react";
import { FiX, FiAlertTriangle } from "react-icons/fi";
import "../../../views/app/productCategories/AddProductCategoryModal.scss";
import "./modals.scss";
import styles from "./ConfirmationModal.module.css";

interface ConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: "danger" | "warning" | "primary";
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onHide,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "danger",
}) => {
  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  if (!show) return null;

  const getIconColor = () => {
    switch (variant) {
      case "danger":
        return "#EC3237";
      case "warning":
        return "#FFA500";
      case "primary":
        return "#00A759";
      default:
        return "#EC3237";
    }
  };

  const getConfirmButtonClass = () => {
    switch (variant) {
      case "danger":
        return styles.confirmButtonDanger;
      case "warning":
        return styles.confirmButtonWarning;
      case "primary":
        return styles.confirmButtonPrimary;
      default:
        return styles.confirmButtonDanger;
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <div className={styles.headerContainer}>
            <FiAlertTriangle size={24} color={getIconColor()} />
            <h2>{title}</h2>
          </div>
          <FiX className="close-icon" onClick={onHide} />
        </div>
        <div className="modal-form">
          <p className={styles.message}>{message}</p>
          <div className={styles.buttonContainer}>
            <button
              type="button"
              onClick={onHide}
              className={styles.cancelButton}
            >
              {cancelText}
            </button>
            <button
              type="button"
              onClick={handleConfirm}
              className={`${styles.confirmButton} ${getConfirmButtonClass()}`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
